import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { NgWizardService } from 'ng-wizard';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ApiService } from 'src/app/services/http/api.service';
import { ToastClientService } from 'src/app/services/toast/toast-client.service';
import { ExportExcelService } from 'src/app/shared/xlsx-view/export-excel.service';

@Component({
  selector: 'app-whitelist-image-task',
  templateUrl: './whitelist-image-task.component.html',
  styleUrls: ['./whitelist-image-task.component.scss']
})
export class WhitelistImageTaskComponent implements OnInit {
  @Input() engagementId = "";
  @Input() engagementType = "";
  @Input() whitelistObj = {};

  @Output() whiteListed: EventEmitter<boolean> = new EventEmitter;


  whitelistUser : any = [];
  getPaginationCount;
  page = 1;

  excelFormat: any = {};
  excelArray: any = [];
  excelData: any = [];
  commonSearch : any = "";
  subTaskList : any = [];
  subTaskId:any = "";
  @Input() zoneData:any =[];
  // stateData:any = [];
  // cityData:any = [];
  zoneId:any =""
  localData: any;
  pointFlag: any;
  constructor(
    private router: Router,
    private exportExcelService: ExportExcelService,
    private apiService: ApiService,
    private apiConfig: ApiConfiguration,
    private toast: ToastClientService,
  ) {
    this.localData = JSON.parse(localStorage.getItem('engagementDetail'))
    this.zoneId = this.localData.zone_id != null ? this.localData.zone_id : ""
    console.log(this.localData)
  }

  ngOnInit() {
    this.fetchZoneTypeData(this.localData.zone_type)
  }
  ngOnChanges(){
    console.log(this.engagementId)
    console.log(this.engagementType)
    this.localData = JSON.parse(localStorage.getItem('engagementDetail'))
    this.zoneId = this.localData.zone_id != null ? this.localData.zone_id : ""
    if(this.engagementId && this.engagementType){
      if(this.localData.has_subtask == 1){
        this.getEnagagementData();
      }else{
        this.getWhitelistUser();
      }
    }
  }
  uploadExcel(){
    this.router.navigate(["/hubAdmin/image-task-setup-excel-upload/"+this.engagementId + "/" + this.engagementType])
  }

  filter(){
    this.getWhitelistUser();
  }

  reset(){
    this.commonSearch = ''
    this.getWhitelistUser()
  }

  refresh(){
    window.location.reload()
  }

  getZoneId(e){
    // console.log(e.target.value);
    this.zoneId = e.target.value
  }
  

  zonebasedWhitelist(){
    console.log(this.localData);
    
    let payload = {
      has_subtask : this.localData.has_subtask,
      sub_tasks_id: this.subTaskId,
      engagement_type : this.engagementType,
      engagement_type_id: this.localData.engagement_type_id,
      task_id: this.localData.task_id,
      whitelist_type : this.localData.whitelist_type,
      zone_type : this.localData.zone_type,
      zone_id : this.zoneId || this.localData.zone_id
    }

    this.apiService.post(this.apiConfig.whiteListEngagementUser, payload).subscribe((res)=>{
      if(res.status == 200){
        this.toast.Success(res.body.data.message)
        this.router.navigate(["/hubAdmin/image-task"])
      }
    })
  }

  fetchZoneTypeData(zone_type){
      if(zone_type==1){
        this.apiService.get(this.apiConfig.configGetRegion).subscribe((res)=>{
          this.zoneData = res['data'].region
          console.log("regionData",this.zoneData);
        })
      }
      if(zone_type==2){
        this.apiService.get(this.apiConfig.configGetStates).subscribe((res)=>{
          this.zoneData = res['data'].state;
          console.log("SateData",this.zoneData);
        })
      }
      if(zone_type==3){
        this.apiService.get(this.apiConfig.configGetCities).subscribe((res)=>{
          this.zoneData = res['data'].cities;
          console.log("cityData",this.zoneData);
        })
      }
  }

  getWhitelistUser(){
    this.excelArray = [];
    this.excelData = [];
    this.apiService.getHeaders(this.apiConfig.engagemetnWhitelistUser + `?engagement_page=${this.page}&engagement_type=${this.engagementType}&task_id=${this.engagementId}&search=${this.commonSearch}`).subscribe((res : any)=>{
      console.log(res)
      this.whitelistUser = res.body.data.data;
      //2) for excelData
      // this.excelData = res.body.data.full_data;
      // for (var k in this.excelData[0]) {
      //   if (typeof this.excelData[k] !== 'function') {
      //     console.log("Key is " + k.replace(/_/g, ' '));
      //     this.excelFormat.header = k.replace(/_/g, ' ');
      //     this.excelFormat.key = k
      //     this.excelArray.push(JSON.parse(JSON.stringify(this.excelFormat)));
      //     console.log(this.excelArray)
      //   }
      // }

      this.getPaginationCount = res.headers.get('X-Pagination-Total-Count')
      this.excelData = res.body.data.full_data;
    })
  }

  DownloadReportExcel() {
    this.exportExcelService.DownloadReportExcel('Point_configuration', this.excelData, this.excelArray);
  }

  paginationClick(e) {
    console.log(e);
    this.page = e;
    this.getWhitelistUser();
  }

  submit(){
   this.whiteListed.emit(true)
  }

  toggleStatus(user){
    let payload = {
      engagement_id: this.localData.engagement_type_id,
      id: user.id,
      status : user.status == 0 ? 1 : 0
    }
  this.apiService.post(this.apiConfig.disableEngagement,payload).subscribe((res : any)=>{
    console.log(res)
    this.getWhitelistUser();
    if(res.status ==200){
      this.toast.Success(res.body.data)
    }else{
      this.toast.Error(res.body.data)
    }
  })
    console.log("toggle")

  }

  viewSubTask(id){
    this.router.navigate(["/hubAdmin/image-sub-engagement/" + id])
  }
  
  getEnagagementData() {
    this.apiService.get(this.apiConfig.viewEngagementDetail + `?engagement_page=1&engagement_type_id=${this.localData.engagement_type_id}&portfolio_id=${this.localData.portfolio_id}&task_id=${this.localData.task_id}`).subscribe((res: any) => {
      console.log(res)
      this.subTaskList = res.data.engagement.sub_tasks;
      this.pointFlag = res.data.engagement.points_calculated

    })
  }
  pointCalc(){
    let payload = {
      task_id:this.localData.task_id,
      engagement_type_id:this.localData.engagement_type_id,
      engagement_page:1,
    }
    this.apiService.post(this.apiConfig.pointCalcEngagement,payload).subscribe((res:any)=>{
      this.getEnagagementData()
      this.toast.Success(res.body.data.message)
    })
  }

}
